import React from 'react'
import Typography from '@material-ui/core/Typography';

const PrivacyPolicy = () => (
  <Typography component="h1" variant="h4">Privacy Policy</Typography>
)

export default PrivacyPolicy;
